import * as Actions from "../actions/_ActionTypes";
import * as Pre from "../actions/_PreActionNames";
import { AppState } from "react-native";
import { Notifications } from "react-native-notifications";

import * as CONSTS from "../../assets/consts";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import { translate } from "../locales/translate";
import CacheStorage from "../modules/cacheStorage";

import * as AccessControlActions from "../actions/AccessControlActions";
import { func } from "prop-types";

// const initState = [...Data.devices];
const initState = {
  isLoading: false,
  includeTimeout: 0,
  includedNodeId: 0, // new node included (used for navigate to DeviceForm after include completed)
  includedNodeUId: undefined, // new node included (used for navigate to DeviceForm after include completed)
  waitingCameraId: undefined,
  waitingCameraUId: undefined,
  rtspServerBaseUrl: undefined,
  doorToAskOpenDeviceId: undefined,
  doorToAskOpenDeviceUId: undefined,
  doorToAskOpenDeviceName: undefined,
  typeEvents: {},
  list: [],
  quickAccess: [],
  playLists: [],
  multiMediasLoaded: false,
  newTouchPanel: null, // show modal after add new Touch Panel and show username and password
  isShowingAccessControlNotification: false,
  accessControlCameraTitle: "",
  accessControlCameraUrl: "",
  accessControlCameraProcessId: 0,
  accessControlAcknowledgements: new Array(),
};

const DeviceReducer = (state = initState, action) => {
  if (state.list.length == 0) {
    new CacheStorage().Devices.GetAll()
      .then((list) => {
        if (Array.isArray(list) && list.length > 0) {
          state.list = list;
        }
      })
      .catch(console.log);
  }
  const _state = { ...state };
  if (action.socket && action.socket.send) {
    if (action.type.indexOf("DEVICE") == 0) {
      _state.isLoading = true;
    }
    return _state;
  }
  var parsedData = null;
  if (action.payload && action.payload.data) {
    parsedData = JSON.parse(action.payload.data);
  }
  switch (action.type) {
    case Pre.DEVICE + Actions.ADD:
    case Pre.DEVICE + Actions.ADD_SILENT:
      if (parsedData) {
        _state.includeTimeout = 0;

        // check to prevent insert duplicated
        var isExist = false;
        for (var i in _state.list) {
          if (
            (parsedData.deviceUId &&
              _state.list[i].deviceUId == parsedData.deviceUId) ||
            _state.list[i].deviceId == parsedData.deviceId
          ) {
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          // if added device is z-wave device (so not a camera) and also action is not silent
          // then set includedNodeId in order to notify user to navigate to edit page
          if (
            parsedData.deviceType != "CAMERA" &&
            action.type != Pre.DEVICE + Actions.ADD_SILENT
          ) {
            // if z-wave device added (not camera)
            _state.includedNodeId = parsedData.deviceId;
          }
          _state.list.push(parsedData);
        }
        new CacheStorage().Devices.SetAll(_state.list);
      }
      break;
    case Pre.DEVICE + Actions.ADD_MULTIPLE:
      _state.includeTimeout = 0;
      // console.log("DeviceReducer.DEVICE_ADD_MULTIPLE", parsedData);
      if (parsedData && Array.isArray(parsedData)) {
        for (var j in parsedData) {
          // check to prevent insert duplicated
          var isExist = false;
          for (var i in _state.list) {
            if (
              (parsedData[j].deviceUId &&
                _state.list[i].deviceUId == parsedData[j].deviceUId) ||
              _state.list[i].deviceId == parsedData[j].deviceId
            ) {
              isExist = true;
              break;
            }
          }
          if (!isExist) {
            if (parsedData[j].deviceType != "CAMERA") {
              // if z-wave device added (not camera)
              _state.includedNodeId = parsedData[j].deviceId;
            }
            _state.list.push(parsedData[j]);
          }
        }

        new CacheStorage().Devices.SetAll(_state.list);
      }
      break;
    case Pre.DEVICE + Actions.UPDATE:
      // will update information of device like name or type.(value won't change.)
      var model = parsedData || action.payload;
      if (model) {
        var oldDevices = [];
        for (var i in _state.list) {
          var ar = _state.list[i];
          if (
            ar.deviceId == model.deviceId ||
            ar?.deviceUId == model.deviceUId
          ) {
            oldDevices.push(ar);
          }
        }
        if (oldDevices.length == 1) {
          var ar = oldDevices[0];
          ar.deviceName = model.deviceName;
          ar.deviceType = model.deviceType;
          ar.showOnHomeScreen = model.showOnHomeScreen;
          if (model.deviceType == DeviceTypes.DOORLOCK) {
            ar.autoCloseSeconds = model.autoCloseSeconds;
            ar.ignoreCommandTimeSeconds = model.ignoreCommandTimeSeconds || 0;
          } else if (model.deviceType == DeviceTypes.AIR_CONDITIONER) {
            ar.commandRelayId = model.commandRelayId;
            ar.commandRelayUId = model.commandRelayUId;
            for (var i in _state.list) {
              if (
                (ar.deviceUId &&
                  _state.list[i].statusRelayUId == ar.deviceUId) ||
                _state.list[i].statusRelayId == ar.deviceId
              ) {
                _state.list[i].statusRelayId = null;
                _state.list[i].statusRelayUId = null;
                break;
              }
            }
            for (var i in _state.list) {
              if (
                (model.commandRelayUId &&
                  _state.list[i].deviceUId == model.commandRelayUId) ||
                _state.list[i].deviceId == model.commandRelayId
              ) {
                _state.list[i].statusRelayId = ar.deviceId;
                _state.list[i].statusRelayUId = ar.deviceUId;
                break;
              }
            }
          } else if (model.deviceType == DeviceTypes.DOORBELL) {
            ar.doorbellSMSBehavior = model.doorbellSMSBehavior;
          } else if (model.deviceType == DeviceTypes.SIREN) {
            if (Number.isInteger(model.gpioPortNumber)) {
              ar.gpioPortNumber = model.gpioPortNumber;
            }
          } else if (model.deviceType == DeviceTypes.SMART_SPEAKER) {
            ar.ip = model.ip;
            ar.port = model.port;
            ar.protocol = model.protocol;
          }
        } else {
          for (var i in oldDevices) {
            var ar = oldDevices[i];
            ar.deviceName = model.deviceName;
            //ar.deviceType = model.deviceType;
            if (model.deviceType == DeviceTypes.DOORLOCK) {
              ar.autoCloseSeconds = model.autoCloseSeconds;
              ar.ignoreCommandTimeSeconds = model.ignoreCommandTimeSeconds || 0;
            } else if (model.deviceType == DeviceTypes.DOORBELL) {
              ar.doorbellSMSBehavior = model.doorbellSMSBehavior;
            }
          }
        }
        // console.log('oldDevices', oldDevices)
        new CacheStorage().Devices.SetAll(_state.list);
      }
      break;
    case Pre.DEVICE + Actions.REMOVE:
      if (action.payload.deviceUId) {
        for (var i in _state.list) {
          if (_state.list[i].deviceUId == action.payload.deviceUId) {
            // removing i_th element using splice(index , length)
            _state.list.splice(i, 1);
            break;
          }
        }
        new CacheStorage().Devices.SetAll(_state.list);
      } else if (action.payload.deviceId) {
        for (var i in _state.list) {
          if (_state.list[i].deviceId == action.payload.deviceId) {
            // removing i_th element using splice(index , length)
            _state.list.splice(i, 1);
            break;
          }
        }
        new CacheStorage().Devices.SetAll(_state.list);
      }
      break;
    case Pre.DEVICE + Actions.DETAILS:
      if (!parsedData && action.payload) parsedData = action.payload;
      for (let i = 0; i < _state.list.length; i++) {
        if (parsedData.deviceUId) {
          if (
            _state.list[i].deviceUId == parsedData.deviceUId &&
            _state.list[i].deviceType == parsedData.deviceType
          ) {
            _state.list[i] = parsedData;
            break;
          }
        } else {
          if (
            _state.list[i].deviceId == parsedData.deviceId &&
            _state.list[i].deviceType == parsedData.deviceType
          ) {
            _state.list[i] = parsedData;
            break;
          }
        }
      }
      break;
    // === Update Device Controller ===
    case Pre.DEVICE + Actions.UPDATE_CONTROLLER:
      console.log("payload", action.payload);
      break;

    case Pre.DEVICE + Actions.ALL:
      if (parsedData && Array.isArray(parsedData)) {
        _state.list = parsedData;
        // console.log(
        //   `received ${parsedData.length} device(s) in DeviceReducer.ALL`
        // );
        for (var i in parsedData) {
          var newDevice = parsedData[i];
          if (newDevice.deviceType == "SMART_SPEAKER") {
            if (newDevice.slavesListCsv) {
              newDevice.slavesList = newDevice.slavesListCsv.split(",");
            } else {
              newDevice.slavesList = [];
            }
          }
          var existed = _state.list.filter(
            (d) =>
              (d.deviceUId == newDevice.deviceUId ||
                (!newDevice.deviceUId && d.deviceId == newDevice.deviceId)) &&
              d.deviceType == newDevice.deviceType &&
              (d.deviceType != DeviceTypes.VOLTAGE_SENSOR ||
                d.phaseNumber == newDevice.phaseNumber)
          )[0];
          if (existed) {
            _state.list[_state.list.indexOf(existed)] = newDevice;
          } else {
            _state.list.push(newDevice);
          }
        }
      }
      new CacheStorage().Devices.SetAll(_state.list);
      break;
    case Pre.DEVICE + Actions.ALL_PARTIAL:
      if (parsedData && Array.isArray(parsedData)) {
        for (var i in parsedData) {
          var newDevice = parsedData[i];
          var existed = _state.list.filter(
            (d) =>
              (d.deviceUId == newDevice.deviceUId ||
                (!newDevice.deviceUId && d.deviceId == newDevice.deviceId)) &&
              d.deviceType == newDevice.deviceType
          )[0];
          if (existed) {
            _state.list[_state.list.indexOf(existed)] = newDevice;
          } else {
            // check one more time without type
            existed = _state.list.filter(
              (d) =>
                d.deviceUId == newDevice.deviceUId ||
                (!newDevice.deviceUId && d.deviceId == newDevice.deviceId)
            )[0];
            // if newDevice.deviceType is not between allowed multiple sensors, replace new device with old one
            if (
              existed &&
              [
                DeviceTypes.MOTION_SENSOR,
                DeviceTypes.LIGHT_METER,
                DeviceTypes.THERMO_METER,
              ].indexOf(newDevice.deviceType) < 0
            ) {
              _state.list[_state.list.indexOf(existed)] = newDevice;
            } else {
              _state.list.push(newDevice);
            }
          }
        }
        new CacheStorage().Devices.SetAll(_state.list);
      }
      break;
    case Pre.DEVICE + Actions.ALL_SUMMARIES:
      var indexesToRemove = [];
      for (var i in _state.list) {
        var dvc = _state.list[i];
        if (
          !parsedData.some(
            (s) =>
              (s.deviceUId == dvc.deviceUId ||
                (!dvc.deviceUId && s.deviceId == dvc.deviceId)) &&
              s.deviceType == dvc.deviceType
          )
        ) {
          indexesToRemove.push(i);
        }
      }

      if (indexesToRemove.length > 0) {
        for (var i = indexesToRemove.length - 1; i >= 0; i--) {
          _state.list.splice(i, 1);
        }

        // rewrite cache only if device list is changed
        new CacheStorage().Devices.SetAll(_state.list);
      }

      break;
    case Pre.DEVICE + Actions.CLEAR:
      _state.list = [];
      new CacheStorage().Devices.ClearAll();
      break;
    case Pre.DEVICE + Actions.TYPE_EVENTS:
      if (parsedData) {
        _state.typeEvents = parsedData;
      }
      break;
    case Pre.DEVICE + Actions.INCLUDE_NODE_GET_TIMEOUT:
      let t = 0;
      if (parsedData) {
        t = Number(parsedData.timeout) || 0;
      }
      _state.includeTimeout = t;

      break;
    case Pre.DEVICE + Actions.ADD_DOOR_SENSOR:
      // check to prevent insert duplicated
      var isExist = false;
      for (var i in _state.list) {
        if (
          (_state.list[i].deviceUId == parsedData.deviceUId ||
            (!parsedData.deviceUId &&
              _state.list[i].deviceId == parsedData.deviceId)) &&
          _state.list[i].deviceType == DeviceTypes.DOOR_SENSOR
        ) {
          isExist = true;
          _state.list[i].isOpen = parsedData.isOpen;
          break;
        }
      }
      if (!isExist) {
        _state.list.push(parsedData);
      }
      break;
    case Pre.DEVICE + Actions.COUNT_DOWN_TIMEOUT:
      if (Number(_state.includeTimeout) && _state.includeTimeout > 0) {
        _state.includeTimeout--;
      }
      break;
    case Pre.LEAK_DETECTOR + Actions.UPDATE_VALUE:
      var device = _state.list.find((d) => {
        return (
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
        );
      });
      if (device) {
        device.detected = parsedData.detected || false;
      }
      _state.list[_state.list.indexOf(device)] = device;
      break;
    case Pre.LIGHT + Actions.TOGGLE_SWITCH:
      var device = _state.list.find((d) => {
        return (
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
        );
      });
      if (device) {
        device.isTurnedOn = parsedData.isTurnedOn;
      }
      break;
    case Pre.LIGHT + Actions.UPDATE_VALUE:
      var device = _state.list.find((d) => {
        return (
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
        );
      });
      if (device) {
        device.isTurnedOn = parsedData.isTurnedOn || parsedData.value || false;
      }
      break;
    case Pre.SIREN + Actions.UPDATE_VALUE:
      var device = _state.list.find((d) => {
        return (
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
        );
      });
      if (device) {
        device.isTurnedOn = parsedData.isTurnedOn || parsedData.value || false;
      }
      break;
    case Pre.POWER_SWITCH + Actions.UPDATE_VALUE:
      var device = _state.list.find((d) => {
        return (
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
        );
      });
      if (device) {
        device.isTurnedOn = parsedData.isTurnedOn || parsedData.value || false;
      }
      break;
    case Pre.WATERING_SWITCH + Actions.UPDATE_VALUE:
      var device = _state.list.find((d) => {
        return (
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
        );
      });
      if (device) {
        device.isTurnedOn = parsedData.isTurnedOn || parsedData.value || false;
      }
      break;

    case Pre.SENSOR_BINARY + Actions.UPDATE_VALUE:
      var device = _state.list.find((d) => {
        return (
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
        );
      });
      if (device) {
        device.value = parsedData.value || false;
      }
      break;

    case Pre.ELEVATOR + Actions.STATE:
      var device = _state.list.filter(
        (d) =>
          d.deviceId == parsedData.deviceId ||
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId)
      )[0];
      var model = parsedData;
      //console.log(`model passed in ELEVATOR_STATE`, model)
      if (device) {
        device.currentFloor = model.floor;
        device.directionLabel = model.direction;
        device.direction = model.directionValue;
      }
      break;
    case Pre.ELEVATOR + Actions.FLOOR_STATE:
      var device = _state.list.filter(
        (d) =>
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
      )[0];
      var model = parsedData;
      //console.log(`model passed in ELEVATOR_FLOOR_STATE`, model)

      if (device) {
        if (Array.isArray(model.panel)) {
          for (var i in device.elevatorFloors) {
            var isPressed = model.panel.includes(
              device.elevatorFloors[i].floorLevel
            );
            device.elevatorFloors[i].isPressed = isPressed;
          }
        } else {
          // old way for backward compatibility
          for (var i in device.elevatorFloors) {
            if (device.elevatorFloors[i].id == model.floorId) {
              device.elevatorFloors[i].isPressed = model.isPressed;
            }
          }
        }
      }
      break;
    case Pre.ELEVATOR + Actions.UPDATE:
      var device = _state.list.filter(
        (d) =>
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
      )[0];
      var model = parsedData;
      // console.log(device);
      if (device) {
        device.name = model.name;
        device.hardWareCode = model.hardWareCode;
        device.elevatorFloors = model.elevatorFloors;
        device.isOutOfService = model.isOutOfService;
      }
      break;
    case Pre.ELEVATOR + Actions.VIP:
      var device = _state.list.find(
        (d) =>
          d.deviceId == parsedData.deviceId ||
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId)
      );
      if (device) {
        device.hasVIP = parsedData?.hasVIP;
        device.vipEnabled = parsedData?.vipEnabled;
      }
      break;

    case Pre.HIDDEN_SWITCH + Actions.UPDATE_VALUE:
      var device = _state.list.find((d) => {
        return (
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
        );
      });
      if (device) {
        device.isTurnedOn = parsedData.isTurnedOn || parsedData.value || false;
      }
      break;
    case Pre.OUTLET + Actions.UPDATE_VALUE:
      var device = _state.list.find((d) => {
        return (
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
        );
      });
      if (device) {
        device.isTurnedOn = parsedData.isTurnedOn || parsedData.value || false;
      }
      break;
    case Pre.CURTAIN + Actions.UPDATE_VALUE:
      if (parsedData) {
        for (var i in _state.list) {
          if (
            (parsedData.deviceUId &&
              _state.list[i].deviceUId == parsedData.deviceUId) ||
            _state.list[i].deviceId == parsedData.deviceId
          ) {
            _state.list[i].value = parsedData.value;
            break;
          }
        }
      }
      break;
    case Pre.CURTAIN + Actions.UPDATE_VALUE + "_LOCAL":
      if (action.payload) {
        for (var i in _state.list) {
          if (
            (action.payload.deviceUId &&
              _state.list[i].deviceUId == action.payload.deviceUId) ||
            _state.list[i].deviceId == action.payload.deviceId
          ) {
            _state.list[i].userValue = action.payload.value;
            break;
          }
        }
      }
      break;

    case Pre.POWER_SWITCH + Actions.TOGGLE_SWITCH:
      var device = _state.list.find((d) => {
        return (
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
        );
      });
      if (device) {
        device.isTurnedOn = parsedData.isTurnedOn;
      }
      break;
    case Pre.DIMMER_LIGHT + Actions.UPDATE_VALUE:
      var device = _state.list.find((d) => {
        return (
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
        );
      });
      if (device) {
        device.value = parsedData.value;
      }
      break;
    case Pre.MOTION_SENSOR + Actions.UPDATE_VALUE:
      var device = _state.list.filter((d) => {
        if (
          ((parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
            d.deviceId == parsedData.deviceId) &&
          d.deviceType == DeviceTypes.MOTION_SENSOR
        )
          return d;
      })[0];
      if (device) {
        device.movementDetected = parsedData.detected;
      }
      break;
    case Pre.THERMOMETER + Actions.UPDATE_VALUE:
      // single sensors
      var device = _state.list.filter((d) => {
        if (
          ((parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
            d.deviceId == parsedData.deviceId) &&
          d.deviceType == DeviceTypes.THERMO_METER
        )
          return d;
      })[0];
      if (device) {
        device.value = parsedData.value;
        device.unit = parsedData.unit;
      }

      // integrated sensor into thermostat
      var deviceThermostat = _state.list.filter((d) => {
        if (
          ((parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
            d.deviceId == parsedData.deviceId) &&
          d.deviceType == DeviceTypes.AIR_CONDITIONER
        )
          return d;
      })[0];
      if (deviceThermostat) {
        deviceThermostat.currentTemperature = parsedData.value;
      }

      break;
    case Pre.HUMIDITY + Actions.UPDATE_VALUE:
      // single sensors
      var device = _state.list.filter((d) => {
        if (
          ((parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
            d.deviceId == parsedData.deviceId) &&
          d.deviceType == DeviceTypes.HUMIDITY_SENSOR
        )
          return d;
      })[0];
      if (device) {
        device.value = parsedData.value;
        device.unit = parsedData.unit;
      }

      // integrated sensor into thermostat
      var deviceThermostat = _state.list.filter((d) => {
        if (
          ((parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
            d.deviceId == parsedData.deviceId) &&
          d.deviceType == DeviceTypes.AIR_CONDITIONER
        )
          return d;
      })[0];
      if (deviceThermostat) {
        deviceThermostat.humidity = parsedData.value;
      }

      break;
    case Pre.VOLTAGE + Actions.UPDATE_VALUE:
      var device = _state.list.filter((d) => {
        if (
          ((parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
            d.deviceId == parsedData.deviceId) &&
          d.deviceType == DeviceTypes.VOLTAGE_SENSOR &&
          ((d.phaseNumber == 0 && parsedData.phaseNumber == 1) ||
            d.phaseNumber == parsedData.phaseNumber)
        )
          return d;
      })[0];
      if (device) {
        device.value = parsedData.value;
        device.unit = parsedData.unit;
      }
      break;
    case Pre.LIGHT_METER + Actions.UPDATE_VALUE:
      var device = _state.list.filter((d) => {
        if (
          ((parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
            d.deviceId == parsedData.deviceId) &&
          d.deviceType == DeviceTypes.LIGHT_METER
        )
          return d;
      })[0];
      if (device) {
        device.value = parsedData.value;
        device.unit = parsedData.unit;
      }
      break;
    case Pre.AIR_CONDITIONER + Actions.TOGGLE_SWITCH:
      var device = _state.list.find((d) => {
        return (
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
        );
      });
      if (device) {
        device.value = parsedData.value;
      }
      break;

    case Pre.AIR_CONDITIONER + Actions.UPDATE_VALUE:
      var device = _state.list.find((d) => {
        return (
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
        );
      });
      if (device) {
        device.isTurnedOn = parsedData.isTurnedOn;
        device.zhvacMode = parsedData.zhvacMode;
        device.zhvacFanSpeed = parsedData.zhvacFanSpeed;
        device.setPoint = parsedData.setPoint;
        device.currentTemperature = parsedData.currentTemperature;
      }
      break;
    case Pre.AIR_CONDITIONER + Actions.UPDATE_THERMOSTAT_FAN_STATE:
      var device = _state.list.filter(
        (d) =>
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
      )[0];
      if (device) {
        device.thermostatFanState = parsedData.thermostatFanState;
      }
      break;
    case Pre.AIR_CONDITIONER + Actions.UPDATE_THERMOSTAT_FAN_MODE:
      var device = _state.list.filter(
        (d) =>
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
      )[0];
      if (device) {
        device.thermostatFanMode = parsedData.thermostatFanMode;
      }
      break;
    case Pre.AIR_CONDITIONER + Actions.UPDATE_SET_POINT:
      var device = _state.list.filter(
        (d) =>
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
      )[0];
      if (device) {
        device.setPoint = parsedData.setPoint;
        device.setPointUnit = parsedData.setPointUnit;
      }
      break;
    case Pre.AIR_CONDITIONER + Actions.UPDATE_THERMOSTAT_MODE:
      var device = _state.list.filter(
        (d) =>
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
      )[0];
      if (device) {
        device.thermostatMode = parsedData.thermostatMode;
        device.economyEnabled = parsedData.economyEnabled;
        if (parsedData.isTurnedOn != undefined) {
          device.isTurnedOn = parsedData.isTurnedOn;
        }
      }
      break;
    case Pre.AIR_CONDITIONER + Actions.UPDATE_THERMOSTAT_OPERATING_STATE:
      var device = _state.list.filter(
        (d) =>
          (parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
          d.deviceId == parsedData.deviceId
      )[0];
      if (device) {
        device.thermostatOperatingState = parsedData.thermostatOperatingState;
      }
      break;

    case Pre.DEVICE + Pre.PLAY_LIST + Actions.ALL:
      _state.playLists = parsedData;
      _state.multiMediasLoaded = true;
      break;
    case Pre.DEVICE + Pre.PLAY_LIST + Actions.ADD:
      if (!Array.isArray(action.payload.tracks)) action.payload.tracks = [];
      _state.playLists.push(action.payload);
      break;
    case Pre.DEVICE + Pre.PLAY_LIST + Actions.UPDATE:
      for (const i in _state.playLists) {
        if (
          _state.playLists[i]?.id == action.payload?.id ||
          _state.playLists[i].uId == action.payload.uId
        ) {
          _state.playLists[i].isPublic = action.payload.isPublic;
          _state.playLists[i].title = action.payload.title;
          break;
        }
      }
      break;
    case Pre.DEVICE + Pre.PLAY_LIST + Actions.DELETE:
      for (const i in _state.playLists) {
        if (
          _state.playLists[i]?.id == parsedData.id ||
          _state.playLists[i].uId == parsedData.uId
        ) {
          _state.playLists.splice(i, 1);
          break;
        }
      }
      break;
    case Pre.DEVICE + Pre.PLAY_LIST + Actions.ADD_TRACK:
      // console.log("track in reducer add track", action.payload);

      for (const i in _state.playLists) {
        if (_state.playLists[i].id == action.payload.playListId) {
          if (!Array.isArray(_state.playLists[i].tracks))
            _state.playLists[i].tracks = [];

          var tracks = [..._state.playLists[i].tracks];
          tracks.push({
            id: action.payload.id,
            isPublic: action.payload.isPublic,
            playListId: action.payload.playListId,
            title: action.payload.title,
            order: action.payload.order,
            ownerId: action.payload.ownerId,
          });

          tracks.sort((a, b) => a.order - b.order);
          // console.log(tracks.length, "tracks in reducer add track", tracks);
          _state.playLists[i].tracks = tracks;
          break;
        }
      }
      break;
    case Pre.DEVICE + Pre.PLAY_LIST + Actions.REMOVE_TRACK:
      for (const i in _state.playLists) {
        if (_state.playLists[i].id == action.payload.playListId) {
          if (Array.isArray(_state.playLists[i].tracks)) {
            for (const j in _state.playLists[i].tracks) {
              if (_state.playLists[i].tracks[j].id == action.payload.trackId) {
                var updatedTracks = [..._state.playLists[i].tracks];
                updatedTracks.splice(j, 1);
                _state.playLists[i].tracks = updatedTracks;
                break;
              }
            }
          }
          break;
        }
      }
      break;
    case Pre.DEVICE + Pre.PLAY_LIST + Actions.RE_ORDER_TRACKS:
      var playList = _state.playLists.filter(
        (p) => p.id == action.payload.playListId
      )[0];
      if (playList && Array.isArray(playList.tracks)) {
        for (var i in playList.tracks) {
          var track = playList.tracks[i];
          var order =
            action.payload.tracks.filter((t) => t.id == track.id)[0]?.Order ||
            -1;
          if (order > 0 && track.order != order) {
            track.order = order;
          }
        }
      }
      break;

    case Pre.SMART_SPEAKER + Actions.PLAY:
    case Pre.SMART_SPEAKER + Actions.NEXT:
    case Pre.SMART_SPEAKER + Actions.PREVIOUS:
    case Pre.SMART_SPEAKER + Actions.RESUME:
      // console.log("parsedData in SMART_SPEAKER_PLAY", parsedData);
      for (const i in _state.list) {
        const device = _state.list[i];
        if (device.deviceId == parsedData.deviceId) {
          // console.log("speaker in SMART_SPEAKER_", device);
          // device.mediaRendererState = CONSTS.MULTI_MEDIA_STATE.playing;
          device.mediaRendererState = parsedData.mediaRendererState;
          device.currentPlayListId = parsedData.currentPlayListId;
          device.currentPlayingTrackId = parsedData.currentPlayingTrackId;
          if (action.type != Pre.SMART_SPEAKER + Actions.RESUME) {
            // reset time
            device.currentPlayingTrackTime = 0;
          }
          //device.currentPlayingTrackTime = parsedData.currentPlayingTrackTime;
          device.currentPlayListTitle = parsedData.currentPlayListTitle;
          device.currentPlayingTrackDuration =
            parsedData.currentPlayingTrackDuration;
          device.currentPlayingTrackTitle = parsedData.currentPlayingTrackTitle;
          break;
        }
      }
      break;
    case Pre.SMART_SPEAKER + Actions.PAUSE:
      // console.log("parsedData in SMART_SPEAKER_PAUSE", parsedData);
      for (const i in _state.list) {
        const device = _state.list[i];
        if (device.deviceId == parsedData.deviceId) {
          device.mediaRendererState = CONSTS.MULTI_MEDIA_STATE.paused;
          break;
        }
      }
      break;
    case Pre.SMART_SPEAKER + Actions.STOP:
      // console.log("parsedData in SMART_SPEAKER_STOP", parsedData);
      for (const i in _state.list) {
        const device = _state.list[i];
        if (device.deviceId == parsedData.deviceId) {
          // console.log("speaker in SMART_SPEAKER_", device);
          device.mediaRendererState = CONSTS.MULTI_MEDIA_STATE.stopped;
          // device.currentPlayListId = null;
          // device.currentPlayingTrackId = null;
          // device.currentPlayingTrackTime = null;
          // device.currentPlayListTitle = null;
          // device.currentPlayingTrackDuration = 0;
          // device.currentPlayingTrackTitle = null;

          break;
        }
      }
      break;
    case Pre.SMART_SPEAKER + Actions.SEEK:
      // console.log("parsedData in SMART_SPEAKER_SEEK", parsedData);
      for (const i in _state.list) {
        const device = _state.list[i];
        if (device.deviceId == parsedData.deviceId) {
          // console.log('device in SEEK', device)
          device.currentPlayingTrackTime = parsedData.targetPosition;
          break;
        }
      }
      break;
    case Pre.SMART_SPEAKER + Actions.CHANGE_VOLUME:
      // console.log("parsedData in SMART_SPEAKER_CHANGE_VOLUME", parsedData);
      for (const i in _state.list) {
        const device = _state.list[i];
        if (device.deviceId == parsedData.deviceId) {
          device.volume = parsedData.volume;
          break;
        }
      }
      break;
    case Pre.SMART_SPEAKER + Actions.TOGGLE_MUTE:
      // console.log("parsedData in SMART_SPEAKER_TOGGLE_MUTE", parsedData);
      for (const i in _state.list) {
        const device = _state.list[i];
        if (device.deviceId == parsedData.deviceId) {
          device.isMuted = parsedData.mute;
          break;
        }
      }
      break;
    case Pre.SMART_SPEAKER + Actions.CHANGE_INPUT_SOURCE:
      // console.log("parsedData in SMART_SPEAKER_TOGGLE_MUTE", parsedData);
      for (const i in _state.list) {
        const device = _state.list[i];
        if (device.deviceId == parsedData.deviceId) {
          device.input = parsedData.input;
          break;
        }
      }
      break;
    case Pre.SMART_SPEAKER + Actions.UPDATE_SLAVE:
      if (action.payload) {
        var { masterDeviceUId, slaveDeviceUId, actionFunction } =
          action.payload;
        if (!masterDeviceUId) {
          var { masterDeviceUId, slaveDeviceUId, actionFunction } = parsedData;
        }
        for (const i in _state.list) {
          const device = _state.list[i];
          if (device.deviceUId == masterDeviceUId) {
            //console.log("device", device);
            if (actionFunction === "ADD") {
              device.slavesList.push(slaveDeviceUId);
            } else {
              device.slavesList = device.slavesList.filter(
                (slaveUId) => slaveUId !== slaveDeviceUId
              );
            }
            break;
          }
        }
      }
      break;

    case Pre.DOORLOCK + Actions.ASK_TO_OPEN:
      // console.log(_state.list.length);
      var device = _state.list.find((d) => {
        return (
          (typeof parsedData === "string" && d.deviceUId == parsedData) ||
          d.deviceId == parsedData
        );
      });
      if (device) {
        _state.doorToAskOpenDeviceId = device.deviceId;
        _state.doorToAskOpenDeviceUId = device.deviceUId;
        _state.doorToAskOpenDeviceName = device.deviceName;
      }
      break;
    case Pre.DOORLOCK + Actions.RESET_ASK_TO_OPEN:
      _state.doorToAskOpenDeviceId = undefined;
      _state.doorToAskOpenDeviceUId = undefined;
      _state.doorToAskOpenDeviceName = undefined;
      break;
    case Pre.CAMERA + Actions.UPDATE:
      // will update information of device like name or type.(value won't change.)
      var model = parsedData;
      if (model) {
        for (var i in _state.list) {
          var c = _state.list[i];
          if (
            c.cameraId == model.cameraId &&
            c.deviceType == DeviceTypes.CAMERA
          ) {
            c.cameraName = model.cameraName;
            c.deviceName = model.cameraName;
            c.ip = model.ip;
            c.port = model.port;
            c.channel = model.channel;
            c.channels = model.channels;
            c.v380DeviceId = model.v380DeviceId;
            c.userName = model.userName;
            c.doorbellDeviceId = model.doorbellDeviceId;
            c.doorbellDeviceIds = model.doorbellDeviceIds;
            c.doorbellDeviceUIds = model.doorbellDeviceUIds;
            // c.passwordHash => never store password in client

            for (var j in _state.list) {
              var dr_bl = _state.list[j];
              if (dr_bl && dr_bl.deviceType == "DOORBELL") {
                if (dr_bl.cameraId == model.cameraId) {
                  if (
                    c.doorbellDeviceId != dr_bl.deviceId ||
                    !c.doorbellDeviceIds.includes(dr_bl.deviceId)
                  ) {
                    dr_bl.cameraId = null; // detach old doorbell
                  }
                }

                if (
                  c.doorbellDeviceId == dr_bl.deviceId &&
                  dr_bl.cameraId == null
                ) {
                  dr_bl.cameraId = c.cameraId; // attach to camera if is not already attached to another camera
                }
              } else if (dr_bl && dr_bl.deviceType == "DOORLOCK") {
                if (dr_bl.cameraId == model.cameraId) {
                  if (c.doorLockDeviceId != dr_bl.deviceId) {
                    dr_bl.cameraId = null; // detach old doorbell
                  }
                }

                if (
                  c.doorLockDeviceId == dr_bl.deviceId &&
                  dr_bl.cameraId == null
                ) {
                  dr_bl.cameraId = c.cameraId; // attach to camera if is not already attached to another camera
                }
              }
            }
            break;
          }
        }
      }
      break;
    case Pre.CAMERA + Actions.SERVER:
      if (parsedData && parsedData.rtspServerBaseUrl) {
        _state.rtspServerBaseUrl = parsedData.rtspServerBaseUrl;
      }
      break;
    case Pre.DOORBELL + Actions.PRESSED:
      //console.log("DeviceReducer.DOORBELL_PRESSED", action.payload.data);
      if (parsedData) {
        // console.log(
        //   `camera with cameraId ${parsedData.cameraId} request from doorbell`,
        //   parsedData
        // );
        if (AppState.currentState != "active") {
          Notifications.postLocalNotification({
            title: translate("device.doorbellPressedNotificationTitle"),
            body: [parsedData.cameraName],
            data: {
              ...parsedData,
              channel: CONSTS.NOTIFICATION_CHANNELS.DOORBELLS,
            },
            android: {
              channelId: CONSTS.NOTIFICATION_CHANNELS.DOORBELLS,
              // icon: require("./assets/icon/icon.png")
            },
          })
            .then()
            .catch(console.log);
        } else {
          // alert(
          //   `camera with cameraId ${parsedData.cameraId} request from doorbell.(DeviceReducer.DOORBELL_PRESSED)`
          // );
          _state.waitingCameraId = parsedData.cameraId;
          _state.waitingCameraUId = parsedData.cameraUId;
        }
      }
      break;
    case Pre.DOORBELL + Actions.PRESSED + "_RESET":
      _state.waitingCameraId = undefined;
      _state.waitingCameraUId = undefined;
      break;
    case Pre.DEVICE + Actions.RESET_NEW_INCLUDED_ID:
      _state.includedNodeId = 0;
      _state.includedNodeUId = undefined;
      break;

    // === TCP Sensor ===
    case Pre.TCPSENSOR + Actions.DOOR_STATE_CHANGED:
      var device = _state.list.filter((d) => {
        if (
          ((parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
            d.deviceId == parsedData.deviceId) &&
          d.deviceType == DeviceTypes.DOOR_SENSOR
        )
          return d;
      })[0];
      if (device) {
        device.doorState = parsedData.doorState;
        if (parsedData.doorState != "E") {
          device.isOpen = parsedData.isOpen;
        }
      }
      break;

    // === Access Control ===
    case Pre.ACCESS_CONTROL + Actions.DOOR_STATE_CHANGED:
      var device = _state.list.filter((d) => {
        if (
          ((parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
            d.deviceId == parsedData.deviceId) &&
          d.deviceType == DeviceTypes.ACCESS_CONTROL
        )
          return d;
      })[0];
      if (device) {
        device.doorState = parsedData.doorState;
      }
      break;
    case Pre.ACCESS_CONTROL + Actions.DEVICE_CONNECTION_CHANGED:
      var device = _state.list.filter((d) => {
        if (
          ((parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
            d.deviceId == parsedData.deviceId) &&
          d.deviceType == DeviceTypes.ACCESS_CONTROL
        )
          return d;
      })[0];
      if (device) {
        device.isDeviceConnected = parsedData.isDeviceConnected;
      }
      break;
    case Pre.ACCESS_CONTROL + Actions.DEVICE_TAMPER_CHANGED:
      var device = _state.list.filter((d) => {
        if (
          ((parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
            d.deviceId == parsedData.deviceId) &&
          d.deviceType == DeviceTypes.ACCESS_CONTROL
        )
          return d;
      })[0];
      if (device) {
        device.isTampered = parsedData.isTampered;
      }
      break;
    case Pre.ACCESS_CONTROL + Actions.SHOW_NOTIFICATION:
      var device = _state.list.filter((d) => {
        if (
          ((parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
            d.deviceId == parsedData.deviceId) &&
          d.deviceType == DeviceTypes.ACCESS_CONTROL
        )
          return d;
      })[0];
      if (device) {
        _state.isShowingAccessControlNotification = device.deviceUId;
        device.accessControlCameraTitle = parsedData.title;
        device.accessControlCameraUrl = parsedData.url;
        // device.accessControlCameraProcessId = parsedData.processId;
        device.accessControlCameraProcessId = Date.now();
        device.accessControlCameraScreenWidth = parsedData.screenWidth;
        device.accessControlCameraScreenHeight = parsedData.screenHeight;
        // device.accessControlCameraStartTime = new Date();
        device.accessControlFailedAttemptCount = parsedData.failedAttemptCount;
        device.accessControlSystemLocked = parsedData.systemLocked;
      }
      break;
    case Pre.ACCESS_CONTROL + Actions.ACK_ANNOUNCEMENT:
      let ack = JSON.parse(action.payload.data);
      _state.accessControlAcknowledgements.push(ack);
      // console.log(ack);
      break;
    case Pre.ACCESS_CONTROL + Actions.ACK_ALL:
      var allAck = JSON.parse(action.payload.data);
      // let arr = new Array();
      // allAck.forEach(item => {
      //   console.log(item);
      //   arr.push(item);
      // });
      // console.log(allAck);
      _state.accessControlAcknowledgements = allAck;
      // console.log(_state.accessControlAcknowledgements);
      break;
    case Pre.ACCESS_CONTROL + Actions.ACK_CONFIRMED:
      var data = JSON.parse(action.payload.data);
      _state.accessControlAcknowledgements =
        _state.accessControlAcknowledgements.filter(function (item) {
          return item.id != data;
        });
      break;
    case Pre.ACCESS_CONTROL + Actions.SYSTEM_LOCK_CHANGED:
      var device = _state.list.filter((d) => {
        if (
          ((parsedData.deviceUId && d.deviceUId == parsedData.deviceUId) ||
            d.deviceId == parsedData.deviceId) &&
          d.deviceType == DeviceTypes.ACCESS_CONTROL
        )
          return d;
      })[0];
      if (device) {
        device.isSystemLocked = parsedData.isSystemLocked;
      }
      break;

    // === Touch Panel ===
    case Pre.DEVICE + Actions.ADD_TOUCH_PANEL:
    case Pre.DEVICE + Actions.UPDATE_TOUCH_PANEL:
      var model = parsedData || action.payload.model;
      if (model) {
        let findDevice = _state.list.find(
          (device) =>
            device.deviceId == model.deviceId ||
            device.deviceUId == model.deviceUId
        );
        if (findDevice) {
          _state.list[_state.list.indexOf(findDevice)] = model;
        } else {
          _state.list.push(model);
          _state.newTouchPanel = model;
        }
        // console.log('oldDevices', oldDevices)
        new CacheStorage().Devices.SetAll(_state.list);
      }
      break;
    case Pre.DEVICE + Actions.CLEAR_NEW_TOUCH_PANEL:
      _state.newTouchPanel = null;
      break;

    case Pre.DEVICE + Actions.UPDATE_BATTERY:
      if (parsedData && Number(parsedData.batteryLevel)) {
        for (var i in _state.list) {
          if (
            (parsedData.deviceUId &&
              _state.list[i].deviceUId == parsedData.deviceUId) ||
            _state.list[i].deviceId == parsedData.deviceId
          ) {
            _state.list[i].batteryLevel = parsedData.batteryLevel;
            break;
          }
        }
      }
      break;
    case Pre.USER + Actions.SET_DEVICE_QUICK_ACCESS:
      if (Array.isArray(action.payload)) _state.quickAccess = action.payload;
      else if (Array.isArray(parsedData)) _state.quickAccess = parsedData;
      break;
    // case Pre.APP + Actions.RECONNECT:
    //   console.log("APP_RECONNECT received in DeviceReducer");
    //   _state.list = [];
    //   break;
    case Actions.CLEAR_CACHE:
    case Actions.LOGOUT:
      // console.log('clear DeviceReducer due to LOGOUT')
      _state.list = [];
      _state.quickAccess = [];
      _state.rtspServerBaseUrl = undefined;
      _state.typeEvents = [];
      var cacheStorage = new CacheStorage();
      cacheStorage.Devices.ClearAll();
      cacheStorage.QuickAccess.ClearAll();
      break;

    case Pre.DEVICE + Actions.ADD_TOUCH_PANEL:
  }
  _state.isLoading = false;
  return _state;
};

export default DeviceReducer;
